






















import * as Palette from '@/assets/palette'
// import testData from '@/test/sounding-data'
import fleche from '@/assets/fleche'
import Vue from 'vue'
// import { SwipeDetector } from 'swipedetector'

export default {
  name: 'sounding-view',

  props: {
    /* topAltitude: {
      type: Number,
      default: 4000
    }, */
    title: {
      type: String,
      default: 'No title'
    },
    showMixingRatios: {
      type: Boolean,
      default: false
    },
    showSaturationAdiabats: {
      type: Boolean,
      default: false
    },
    showDryAdiabats: {
      type: Boolean,
      default: false
    },
    redraw: { type: String }
  },

  data() {
    return {
      canvas: undefined,
      context: undefined,
      height: 0,
      width: 0,
      pxRatio: window.devicePixelRatio || 1,
      waitForRedraw: false,
      cache: {}
    }
  },
  computed: {
    date() {
      return this.$store.getters['time/date']
    },
    run() {
      return this.$store.getters['time/run']
    },
    private() {
      return this.$store.getters['time/private'] && !this.$store.getters['auth/isContributor']
    },
    roundedTime() {
      return this.$store.getters['time/roundedTime']
    },
    hours() {
      const hours = this.roundedTime.getUTCHours()
      return String(`0${hours}`).slice(-2)
    },
    minutes() {
      const minutes = this.roundedTime.getUTCMinutes()
      return String(`0${minutes}`).slice(-2)
    },
    time() {
      return `${this.hours}:${this.minutes}`
    },
    lat() {
      return this.$store.state.persistent.center.lat
    },
    lon() {
      return this.$store.state.persistent.center.lon
    },
    dataUrl() {
      if (this.private) return undefined
      if (this.run === undefined) return undefined
      return `https://data0.meteo-parapente.com/data2017.php?run=${this.run}&location=${this.lat},${this.lon}&date=${this.date}&plot=sounding&time=${this.time}`
    },
    data() {
      return this.dataUrl in this.cache ? this.cache[this.dataUrl] : undefined
    },
    loading() {
      return this.data === undefined && !this.private
    },
    colorblind() {
      return this.$store.state.persistent.colorblind
    },
    topAltitude: {
      get() {
        return this.$store.state.persistent.soundingTopAltitude
      },
      set(val) {
        this.$store.dispatch('persistent/setSoundingTopAltitude', val)
      }
    },
    windUnit() {
      return this.$store.state.persistent.windUnit
    }
  },
  watch: {
    redraw() {
      this.delayedDraw()
    },
    colorblind() {
      this.delayedDraw()
    },
    dataUrl(value) {
      if (value === undefined) {
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
      } else {
        this.loadData()
      }
    },
    lat() {
      this.cache = {}
      if (this.context !== undefined) this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
    },
    lon() {
      this.cache = {}
      if (this.context !== undefined) this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
    },
    date() {
      // this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
    },
    topAltitude() {
      this.delayedDraw()
    },
    windUnit() {
      this.delayedDraw()
    }
  },
  mounted() {
    this.canvas = this.$refs.canvas
    this.context = this.$refs.canvas.getContext('2d')
    window.addEventListener('resize', this.delayedDraw)
    /* const swipe = new SwipeDetector(this.$el).emitter
    swipe.on('left', () => {
      this.$emit('swipe-tab', 1)
    })
    swipe.on('right', () => {
      this.$emit('swipe-tab', -1)
    }) */
    this.loadData()
  },
  activated() {
    this.delayedDraw()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.delayedDraw)
  },

  methods: {
    delayedDraw() {
      if (this.waitForRedraw) return
      this.waitForRedraw = true
      requestAnimationFrame(() => {
        this.draw()
        this.waitForRedraw = false
      })
    },
    loadData() {
      const url = this.dataUrl
      if (this.data === undefined) {
        this.$http.get(url).then(response => {
          if (response.body.status === 'ok') {
            Vue.set(this.cache, url, response.body.data[Object.keys(response.body.data)[0]])
            this.delayedDraw()
          } else if (response.body.error === 'out_of_bounds') {
            Vue.set(this.cache, url, 'no-data')
          }
        })
      } else {
        this.delayedDraw()
      }
    },
    draw() {
      /* eslint no-mixed-operators: 0 */
      /* eslint camelcase: 0 */
      /* eslint no-floating-decimal: 0 */
      /* eslint dot-notation: 0 */
      /* eslint new-cap: 0 */
      /* eslint no-unreachable: 0 */
      /* eslint no-multi-assign: 0 */
      if (this.data === undefined || this.data === 'no-data') return

      this.width = this.canvas.width = this.canvas.clientWidth * this.pxRatio // todo: DPI
      this.height = this.canvas.height = this.canvas.clientHeight * this.pxRatio
      this.context.clearRect(0, 0, this.width, this.height)

      const data = this.data // todo
      // const windUnit = 'kmh'

      const top = this.topAltitude
      const altiOffset = 250
      const m = {
        l: 30 * this.pxRatio,
        r: 30 * this.pxRatio,
        t: 10 * this.pxRatio,
        b: 18 * this.pxRatio
      }
      const boxH = this.height - m.t - m.b
      const boxW = this.width - m.l - m.r
      const alt2px = boxH / top

      this.context.font = `${11 * this.pxRatio}px Arial`

      const altiY = alti => this.height - (alti * alt2px) - m.b

      const tempXY = (temp, alti) => {
        const minT = -15
        const maxT = 50

        const y = altiY(alti)
        // let x = m.l + boxW/3 + alti/top*boxW
        const x = m.l + (temp - minT + 0.009767 * alti) / (maxT - minT) * boxW

        return {
          x,
          y
        }
      }

      const gamma_s = (T, p) => {
        // T en celsius
        // p en hPa

        // from https://code.google.com/p/pywrfplot/

        const cp = 1005.
        const R = 287.04 // gas constant air
        const Rv = 461.5 // gas constant vapor
        const eps = R / Rv
        const L = 2.501e6 // latent heat of vaporization
        const T_zero = 273.15

        // constants used to calculate moist adiabatic lapse rate
        // See formula 3.16 in Rogers&Yau
        const a = 2. / 7.
        const b = eps * L * L / (R * cp)
        const c = a * L / R

        p *= 100 // hPa to Pa

        const esat = 611.2 * Math.exp(17.67 * T / (T + 243.5)) // Rogers&Yau Formula 2.17
        const wsat = eps * esat / (p - esat) // Rogers&Yau 2.18

        const numer = a * (T + T_zero) + c * wsat
        const denom = p * (1 + b * wsat / ((T + T_zero) ** 2))

        return numer / denom * 100 // en hPa
      }

      const T_rwsA = (r_ws, p) => {
        // T en celsius
        // p en hPa

        // http://www.lthe.fr/PagePerso/molinie/pdf_files/slide_meteo.pdf
        // p *= 100 // hPa -> Pa
        r_ws /= 1000 // en kg/kg

        // pression partielle eau saturée, en Pa
        const e_ws = r_ws * p / (0.622 + r_ws)
        const lg = Math.log(e_ws / 6.107) / Math.LN10
        const T = 237.3 * lg / (7.5 - lg)

        return T // en g/Kg
      }

      const T_rwsB = (w, p) => {
        p *= 100
        w /= 1000 // en kg/kg

        const R = 287.04 // gas constant air
        const Rv = 461.5 // gas constant vapor
        const eps = R / Rv

        const es = w * p / (w + eps)

        const ln = Math.log(es / 611.2)
        const T = ln * 243.5 / (17.67 - ln)

        return T
      }

      const nPoints = data['z'].length

      // ter
      const txtLeft = m.l - 3 * this.pxRatio

      const terB = altiY(0)
      const terT = altiY(data['ter'])

      this.context.beginPath()
      this.context.rect(m.l, terT, boxW, terB - terT)
      this.context.fillStyle = '#ccc'
      this.context.fill()
      this.context.textAlign = 'end'
      this.context.fillStyle = '#777'
      this.context.fillText(Math.round(data['ter']), txtLeft, terT)

      // couche conv
      const blB = altiY(data['ter'])
      const blT = altiY(data['ter'] + data['pblh'])
      this.context.beginPath()
      this.context.rect(m.l, blT, boxW, blB - blT)
      this.context.fillStyle = '#ffff77'
      this.context.fill()
      this.context.fillStyle = 'black'

      // altis --------------------
      const nAltis = Math.ceil(top / altiOffset) + 1
      const right = this.width - m.r

      // let txtLeft = m.l - 3
      this.context.textAlign = 'end'
      this.context.strokeStyle = '#BDBDBD'
      for (let i = 0; i < nAltis; i++) {
        const alti = i * altiOffset
        const y = altiY(alti) + 0.5 * this.pxRatio
        if (i % 4 === 0) {
          this.context.fillText(alti, txtLeft, y)
          this.context.lineWidth = 1.5 * this.pxRatio
        } else {
          this.context.lineWidth = 0.5 * this.pxRatio
        }
        this.context.beginPath()
        this.context.moveTo(m.l, y)
        this.context.lineTo(right, y)
        this.context.stroke()
      }

      if (this.showMixingRatios) {
        // rapports de mélange
        this.context.textAlign = 'center'
        const rm = [.4, 1, 2, 3, 5, 8, 12, 20]
        this.context.lineWidth = this.pxRatio
        this.context.strokeStyle = '#5F4C0B'
        this.context.fillStyle = '#5F4C0B'
        this.context['setLineDash']([2 * this.pxRatio])

        for (let i = 0; i < rm.length; i++) {
          let temp = T_rwsA(rm[i], data['p'][0])
          let A = tempXY(temp, data['z'][0])
          this.context.rect(A.x, 0, 10 * this.pxRatio, 10 * this.pxRatio)
          this.context.fill()
          this.context.fillText(rm[i], A.x, A.y + 10 * this.pxRatio)
          this.context.beginPath()
          this.context.moveTo(A.x, A.y)
          for (let j = 1; j < nPoints; j++) {
            if (data['p'][j] < 400) break
            temp = T_rwsB(rm[i], data['p'][j])
            A = tempXY(temp, data['z'][j])
            this.context.lineTo(A.x, A.y)
          }
          this.context.stroke()
        }
        this.context['setLineDash']([])
      }

      if (this.showSaturationAdiabats) {
        // adiabatique saturée
        this.context.lineWidth = this.pxRatio
        this.context.strokeStyle = 'green'
        this.context['setLineDash']([6 * this.pxRatio, 2 * this.pxRatio])
        for (let t = 0; t < 20; t++) {
          let temp = 30 - 5 * t - 0.009767 * data['z'][0]
          const A = tempXY(temp, data['z'][0])
          this.context.beginPath()
          this.context.moveTo(A.x, A.y)
          for (let i = 1; i < nPoints; i++) {
            const dp = data['p'][i - 1] - data['p'][i]
            temp -= dp * gamma_s(temp, data['p'][i])
            const B = tempXY(temp, data['z'][i])
            this.context.lineTo(B.x, B.y)
          }
          this.context.stroke()
        }
        this.context['setLineDash']([])
      }

      if (this.showDryAdiabats) {
        // adiabatique seche -9,767 K/km
        this.context.lineWidth = 0.5 * this.pxRatio
        this.context.strokeStyle = 'green'
        for (let i = 0; i < 10; i++) {
          const temp = 30 - 10 * i
          const A = tempXY(temp, 0)
          const B = tempXY(temp - top * (9.767) / 1000, top)
          this.context.beginPath()
          this.context.moveTo(A.x, A.y)
          this.context.lineTo(B.x, B.y)
          this.context.stroke()
        }
      }

      // axe temps
      this.context.lineWidth = 1
      this.context.strokeStyle = '#BDBDBD'
      this.context.textAlign = 'start'
      this.context.fillStyle = 'black'
      const bottom = this.height - m.b + 13 * this.pxRatio
      for (let i = 0; i < 10; i++) {
        const temp = 30 - 10 * i
        if (temp === 0) {
          this.context.lineWidth = 1.5 * this.pxRatio
        } else {
          this.context.lineWidth = this.pxRatio
        }
        const A = tempXY(temp, 0)
        const B = tempXY(temp, top)
        this.context.beginPath()
        this.context.moveTo(A.x, A.y)
        this.context.lineTo(B.x, B.y)
        this.context.stroke()
        this.context.fillText(temp, A.x, bottom)
      }
      this.context.textAlign = 'end'
      this.context.fillText('T (°C)', m.l + boxW - 2 * this.pxRatio, bottom)

      // température vs alti

      this.context.lineWidth = 2 * this.pxRatio

      for (let i = 1; i < nPoints; i++) {
        const dZ = data['z'][i] - data['z'][i - 1]
        const dT = (data['tc'][i] - data['tc'][i - 1]) / dZ
        const dp = data['p'][i] - data['p'][i - 1]
        const dTs = (dp * gamma_s(data['tc'][i], data['p'][i])) / dZ
        if (dT <= -0.009767) {
          this.context.strokeStyle = '#C02A00'
        } else if (dT < dTs) {
          this.context.strokeStyle = '#0AC000'
        } else {
          this.context.strokeStyle = 'black'
        }

        const A = tempXY(data['tc'][i - 1], data['z'][i - 1])
        const B = tempXY(data['tc'][i], data['z'][i])
        this.context.beginPath()
        this.context.moveTo(A.x, A.y)
        this.context.lineTo(B.x, B.y)
        this.context.stroke()
        // this.context.lineTo(B.x-2, B.y)
        // this.context.lineTo(B.x+2, B.y)
        // this.context.lineTo(B.x, B.y)
      }

      // temp td vs alti
      this.context.beginPath()
      const A = tempXY(data['td'][0], data['z'][0])
      this.context.moveTo(A.x, A.y)
      for (let i = 1; i < nPoints; i++) {
        const B = tempXY(data['td'][i], data['z'][i])
        this.context.lineTo(B.x, B.y)
      }
      this.context.strokeStyle = 'blue'
      this.context.stroke()

      // haut
      this.context.fillStyle = 'white'
      this.context.fillRect(m.l, 0, boxW, m.t)

      // titre
      // this.context.font = '14px Arial'
      // this.context.fillStyle = 'black'
      // this.context.textAlign = 'left'

      // this.context.fillText(this.title, m.l, 14)

      // droite
      const left = m.l + boxW

      this.context.fillStyle = 'white'
      this.context.fillRect(left, 0, m.r, this.height)

      // vent
      this.context.fillStyle = 'black'
      this.context.font = `${10 * this.pxRatio}px Arial`
      this.context.textAlign = 'left'
      let last = altiY(0)
      for (let iz = 0; iz < nPoints; iz++) {
        const alti = data['z'][iz]
        if (alti > top) break
        const alti_top = altiY(alti)
        if (last - alti_top < 10 * this.pxRatio) continue
        last = alti_top
        const milieu = left + m.r / 2
        const u = data['umet'][iz]
        const v = data['vmet'][iz]
        const ms = Math.sqrt(u * u + v * v)
        const kmh = Math.round(ms * 3.6)
        this.context.fillText(Math.round(this.$getwind(ms)), milieu + 4 * this.pxRatio, alti_top)
        /* switch (windUnit) {
          case 'ms':
            this.context.fillText(Math.round(ms), milieu + 4 * this.pxRatio, alti_top)
            break
          default:
          case 'kmh':
            this.context.fillText(kmh, milieu + 4 * this.pxRatio, alti_top)
            break
          case 'nds':
            this.context.fillText(Math.round(ms * 1.94 * this.pxRatio), milieu + 4, alti_top)
            break
        } */
        const w = (4 / 30 * kmh) * this.pxRatio
        const rgb = Palette.getColor(ms, this.colorblind ? 'PAL_WIND_CB' : 'PAL_WIND')
        if (w > 0.1) {
          fleche({
            x: milieu - this.pxRatio,
            y: alti_top,
            a: Math.atan2(u, v) + Math.PI,
            s: 10 * this.pxRatio,
            w,
            color: `rgba(${rgb.r},${rgb.g},${rgb.b},1)`
          }, this.context, this.pxRatio)
        } else {
          this.context.beginPath()
          this.context.arc(milieu - 3 * this.pxRatio, alti_top - 4 * this.pxRatio, this.pxRatio, 0, 2 * Math.PI, true)
          this.context.fill()
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/sounding-view.vue